import { Exclude, Expose, Transform, Type } from 'class-transformer';
import moment, { Moment } from 'moment';
import { PlatformScheduleDTO } from './platform-schedule.dto';
import { PlatformDTO } from './platform.dto';

@Exclude()
export class PlatformScheduleGroupDTO {
  @Expose()
  id: number;

  @Expose()
  @Transform((value) => (moment.isMoment(value) ? value.toISOString() : value), {
    toPlainOnly: true
  })
  @Type(() => moment)
  groupDate: Moment;

  @Expose()
  sortOrder: number;

  @Expose()
  userId: number;

  @Expose()
  workspaceId: number;

  @Expose()
  isDraft: boolean;

  @Expose()
  isExternal: boolean;

  @Expose()
  hasOtherPlatforms: boolean;

  @Expose()
  platformSchedules: PlatformScheduleDTO[];

  @Expose()
  platform: PlatformDTO;

  @Expose()
  get posted(): boolean {
    return this.platformSchedules.length && this.platformSchedules.every((schedule) => schedule.posted);
  }

  selected: boolean;
}
